import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mockProducts } from '../mockData';
import { LegalDocument, PagingData } from '../models';
import { Product, ShippingOption, Store } from '../models/catalog.model';
import { ProductModel } from '../models/ProductModel';
import { PolarJService } from './polarj.service';
import { MODULE_SERVICE_NAME, PolarJServerModelContextPath } from '../constants';
import { AmmIconCategory } from '../../components.global';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private _polarjService: PolarJService = inject(PolarJService);

    fetchCurCategories(): Observable<PagingData<AmmIconCategory>> {
      return this._polarjService.getCall({
        moduleServiceName: MODULE_SERVICE_NAME.CATALOG,
        modelName: PolarJServerModelContextPath.AM_MERCHANDISES,
        requestMappingString: 'merchCategories',
        pageData: true
      });
    }

    fetchCategoryWithIcon(): Observable<PagingData<AmmIconCategory>> {
      return this._polarjService.getCall({
        moduleServiceName: MODULE_SERVICE_NAME.CATALOG,
        modelName: PolarJServerModelContextPath.AM_CATEGORYS,
        requestMappingString: 'firstLevel',
        pageData: true
      });
    }

  getAllMockedProducts(): Observable<ProductModel[] | undefined> {
    return of(mockProducts);
  }

  getShuffledProducts(
    searchKey: string = '',
    productFilter: string = '',
    currentPageIndex: number = 0,
    pageSize: number = 32
  ) {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.API_CATALOG,
      modelName: PolarJServerModelContextPath.AM_MERCHANDISES,
      requestMappingString: 'quickSearchCombined',
      urlPara: `pageIndex=${currentPageIndex}&pageSize=${pageSize}${productFilter}`,
      para: searchKey,
      pageData: true,
    });
  }

  getProducts(
    searchKey: string = '',
    productFilter: string = '',
    currentPageIndex: number = 0,
    pageSize: number = 32
  ) {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.CATALOG,
      modelName: PolarJServerModelContextPath.AM_MERCHANDISES,
      requestMappingString: 'quickSearchCombined',
      urlPara: `pageIndex=${currentPageIndex}&pageSize=${pageSize}${productFilter}`,
      para: searchKey,
      pageData: true,
    });
  }

  getStoreProducts(
    storeCode: string = '',
    currentPageIndex: number = 0,
    pageSize: number = 15
  ): Observable<PagingData<Product>> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.CATALOG,
      modelName: PolarJServerModelContextPath.AM_MERCHANDISES,
      requestMappingString: 'quickSearchCombined',
      urlPara: `pageIndex=${currentPageIndex}&pageSize=${pageSize}&storeCode=${storeCode}`,
      pageData: true,
    });
  }

  getProductsByFamilyCode(familyCode: string): Observable<Product> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.CATALOG,
      modelName: PolarJServerModelContextPath.AM_MERCHFAMILYS,
      requestMappingString: `detail/${familyCode}`,
      singleData: true,
    });
  }
  getAutoComplete(searchKey: string): Observable<Array<string>> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.CATALOG,
      modelName: PolarJServerModelContextPath.AM_KEYWORDS,
      requestMappingString: 'searchByKey',
      para: searchKey,
      listData: true,
    });
  }

  getProductById(id: number): Observable<Product> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.CATALOG,
      modelName: PolarJServerModelContextPath.AM_MERCHANDISES,
      requestMappingString: `${id}`,
      singleData: true,
    });
  }

  getStoreShippingOptions(storeCode: string): Observable<ShippingOption[]> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.MERCHANT,
      modelName: PolarJServerModelContextPath.AM_STORES,
      requestMappingString: `${storeCode}/shippingOption`,
    });
  }

  getIndividualStoreByCode(code: string): Observable<Store> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.MERCHANT,
      modelName: PolarJServerModelContextPath.AM_STORES,
      requestMappingString: `byCodes/${code}`,
      singleData: true,
    });
  }

  getStoreByCodes(codes: string[]): Observable<Store[]> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.MERCHANT,
      modelName: PolarJServerModelContextPath.AM_STORES,
      requestMappingString: `byCodes/${codes.join(',')}`,
      listData: true
    });
  }

  //目前后端会把所有的文章传过来，由前端search排序。
  getPlatformLegalDocs(docType: string): Observable<Array<LegalDocument>> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.MERCHANT,
      modelName: PolarJServerModelContextPath.AM_PLATFORM_LEGAL_DOCS,
      requestMappingString: 'search',
      para: { documentType: docType },
      urlPara:'sorts=version desc',
      listData: true,
    });
  }
}
